module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bd5dbefe48e72f4358d96f907b42497d.png";